export enum EOperationActionType {
  LOAD_SUCCESS = 'workspace/operations/LOAD_SUCCESS',
  CREATE_OR_UPDATE = 'workspace/operations/CREATE_OR_UPDATE',
  DELETE = 'workspace/operations/DELETE',
  ITEMS_DELETED = 'workspace/operations/ITEMS_DELETED',
  ITEM_UPDATED = 'workspace/operations/CANCEL',
  VOLATILE_CREATE_OR_UPDATE = 'workspace/operations/VOLATILE_CREATE_OR_UPDATE',
}
